<!-- MOLECULE: AccountMenuCardHeading.vue -->
<!-- Account menu heading showing user avatar, full name, and email address. -->

<script setup lang="ts">
//
// Props & Emits
//
withDefaults(
  defineProps<{
    userName: string;
    userEmail: string;
    userInitials: string;
    size?: number;
    avatarColor?: string;
  }>(),
  {
    userName: "User Name",
    userEmail: "example@email.com",
    userInitials: "?",
    size: 60,
    avatarColor: "primary",
  },
);
</script>

<template>
  <div class="bg-secondary rounded-lg ma-4 px-4 py-6">
    <div class="mx-auto text-center">
      <div>
        <v-avatar :color="avatarColor" :size="size" class="text-white font-weight-bold">
          <span class="text-h5">
            {{ userInitials }}
          </span>
        </v-avatar>

        <h3 class="mt-3 mb-n1 text-subtitle-2 font-weight-bold">
          {{ userName }}
        </h3>

        <p class="text-caption mx-auto text-center">
          {{ userEmail }}
        </p>
      </div>
    </div>
  </div>
</template>
